import { get } from '../index';

export const getUserAccessToken = () => {
  return get(`/access-token`);
};